import React from "react";
import "./HardwareSolution.css";
import { FormattedMessage } from "react-intl";

import HardwareRobots from "images/robots/goopter-hardware-solution-robots.jpg";
import Bellabot from "images/goopter-robots-bellabot.jpg";
import Pudubot from "images/goopter-pudubot.png";
import Disindection from "images/goopter-robots-disinfection.png";
import Promobot from "images/robots/goopter-hardware-solution-promobot.jpg";
import Flashbot from "images/robots/goopter-hardware-flashbot.jpg";
import WaitingFor from "components/Banner/WaitingFor";
import { ReactComponent as RightGraphic } from "images/background/right-box-graphic.svg";
import { ReactComponent as LeftGraphic } from "images/background/left-box-graphic.svg";
import { Link } from "react-router-dom";
import PopularUseCases from "./PopularUseCases";
import OtherUseCases from "components/Banner/UsecasesBanner";
// import PageHeader from "components/PageHeader/TitleSubtitlePageHeader";
import HardwarePageHeader from "components/PageHeader/TitleSubtitlePageHeader/Hardware";


const Index = () => {
  return (
    <section>
      <div className="HardwareSection">
        <HardwarePageHeader
          title="hardware_data_title1"
          subtitle="hardware_data_title2"
          subtitleColorGreen={false}
        />
        <div className="RobotSection">
          <div className="row">
            <div className="col">
              <img
                src={HardwareRobots}
                className="HeaderImg"
                alt="background"
              />
            </div>
          </div>
          <div className="container div-wrapper">
            <div className="row">
              <div className="col">
                <div className="ImgCard">
                  <Link to="/bellabot-restaurant-delivery-robot">
                    <img src={Bellabot} className="RobotImg" alt="background" />
                  </Link>
                </div>
                <div className="ImgBox">
                  <h2>
                    <FormattedMessage id={"bellabot"} />
                  </h2>
                  <ul>
                    <li>
                      <FormattedMessage id={"hardware_robot_bella_li1"} />
                    </li>
                    <li>
                      <FormattedMessage id={"hardware_robot_bella_li2"} />
                    </li>
                    <li>
                      <FormattedMessage id={"hardware_robot_bella_li3"} />
                    </li>
                  </ul>
                  <div className="btn red-btn">
                    <Link
                      to="/bellabot-restaurant-delivery-robot"
                      className="text-white"
                    >
                      <FormattedMessage id={"explore"} />
                    </Link>
                  </div>
                </div>
              </div>
              <div className="col">
                <div className="ImgCard">
                  <Link to="/pudubot-food-delivery-robot">
                    <img src={Pudubot} className="RobotImg" alt="background" />
                  </Link>
                </div>
                <div className="ImgBox">
                  <h2>
                    {/* <FormattedMessage id={"hardware_robot_ul_4"} /> */}
                    <FormattedMessage id={"pudubot"} />
                  </h2>
                  <ul>
                    <li>
                      <FormattedMessage id={"hardware_robot_pudubot_li1"} />
                    </li>
                    <li>
                      <FormattedMessage id={"hardware_robot_pudubot_li2"} />
                    </li>
                    <li>
                      <FormattedMessage id={"hardware_robot_pudubot_li3"} />
                    </li>
                    <li>
                      <FormattedMessage id={"hardware_robot_pudubot_li4"} />
                    </li>
                  </ul>
                  <div className="btn red-btn">
                    <Link
                      to="/pudubot-food-delivery-robot"
                      className="text-white"
                    >
                      <FormattedMessage id={"explore"} />
                    </Link>
                  </div>
                </div>
              </div>
              <div className="col">
                <div className="ImgCard">
                  <Link to="/disinfectionbot-autonomous-disinfection-robot">
                    <img
                      src={Disindection}
                      className="RobotImg"
                      alt="background"
                    />
                  </Link>
                </div>
                <div className="ImgBox">
                  <h2>
                    {/* <FormattedMessage id={"hardware_robot_ul_3"} /> */}
                    <FormattedMessage id={"disinfectionbot"} />
                  </h2>
                  <ul>
                    <li>
                      <FormattedMessage
                        id={"hardware_robot_disinfection_li1"}
                      />
                    </li>
                    <li>
                      <FormattedMessage
                        id={"hardware_robot_disinfection_li2"}
                      />
                    </li>
                    <li>
                      <FormattedMessage
                        id={"hardware_robot_disinfection_li3"}
                      />
                    </li>
                    <li>
                      <FormattedMessage
                        id={"hardware_robot_disinfection_li4"}
                      />
                    </li>
                  </ul>
                  <div className="btn red-btn">
                    <Link
                      to="/disinfectionbot-autonomous-disinfection-robot"
                      className="text-white"
                    >
                      <FormattedMessage id={"explore"} />
                    </Link>
                  </div>
                </div>
              </div>
            </div>

            <div className="rightBxFrame">
              <RightGraphic className="rightBxFrame" />
            </div>
            <div className="leftFrame">
              <LeftGraphic className="LeftFlastbot-svg" />
            </div>
            <div className="section2">
              <div className="row justify-content-center">
                <div className="col">
                  <div className="ImgCard">
                    <Link to="/promobot-promotional-delivery-robot">
                      <img
                        src={Promobot}
                        className="RobotImg"
                        alt="background"
                      />
                    </Link>
                  </div>
                  <div className="ImgBox">
                    <h2>
                      {/* <FormattedMessage id={"hardware_robot_ul_4"} /> */}
                      <FormattedMessage id={"promobot"} />
                    </h2>
                    <ul>
                      <li>
                        <FormattedMessage id={"hardware_robot_promobot_li1"} />
                      </li>
                      <li>
                        <FormattedMessage id={"hardware_robot_promobot_li2"} />
                      </li>
                      <li>
                        <FormattedMessage id={"hardware_robot_promobot_li3"} />
                      </li>
                    </ul>
                    <div className="btn red-btn">
                      <Link
                        to="/promobot-promotional-delivery-robot"
                        className="text-white"
                      >
                        <FormattedMessage id={"explore"} />
                      </Link>
                    </div>
                  </div>
                </div>
                <div className="col">
                  <div className="ImgCard">
                    <Link to="/flashbot-building-delivery-robot">
                      <img
                        src={Flashbot}
                        className="RobotImg"
                        alt="background"
                      />
                    </Link>
                  </div>
                  <h2>
                    {" "}
                    <FormattedMessage id={"flashbot"} />
                  </h2>
                  <div className="ImgBox">
                    <ul>
                      <li>
                        <FormattedMessage id={"hardware_robot_flashbot_li1"} />
                      </li>
                      <li>
                        <FormattedMessage id={"hardware_robot_flashbot_li2"} />
                      </li>
                      <li>
                        <FormattedMessage id={"hardware_robot_flashbot_li3"} />
                      </li>
                      <li>
                        <FormattedMessage id={"hardware_robot_flashbot_li4"} />
                      </li>
                    </ul>
                    <div className="btn red-btn">
                      <Link
                        to="/flashbot-building-delivery-robot"
                        className="text-white"
                      >
                        <FormattedMessage id={"explore"} />
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <PopularUseCases />

        <div className="rightFrame">
          <RightGraphic className="RightFlastbot-svg" />
        </div>
        <div className="leftFrame">
          <LeftGraphic className="LeftFlastbot-svg" />
        </div>
        <OtherUseCases />
        <WaitingFor />
      </div>
    </section>
  );
};

export default Index;
